import { render, staticRenderFns } from "./outsider.vue?vue&type=template&id=5cf51b26&"
import script from "./outsider.vue?vue&type=script&lang=js&"
export * from "./outsider.vue?vue&type=script&lang=js&"
import style0 from "./outsider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports